import { Modal } from 'antd';
import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateProps } from '../../../contextRedux/ProviderGroup/ProviderGroupModel';
import { RootState } from '../../../store';
import ProviderGroupForm from '../ProviderGroupForm/ProviderGroupForm';

const ProviderGroupModal: FC = () => {
  const dispatch = useDispatch();
  const reduxProviderGroup = useSelector((state: RootState) => state.models.providerGroup);

  return (
    <Modal
      title={!!reduxProviderGroup.id ? 'Modifica' : 'Adauga'}
      open={reduxProviderGroup.props.isModalVisible}
      onCancel={() => dispatch(updateProps({ field: 'isModalVisible', value: false }))}
      width={700}
      footer={null}
    >
      <ProviderGroupForm />
    </Modal>
  );
};

export default ProviderGroupModal;
